import SuccessModal from './SuccessModal';
import SuccessModalContainer from './SuccessModalContainer';

export default SuccessModal;
export { SuccessModalContainer };